import { render, staticRenderFns } from "./GridSystem.vue?vue&type=template&id=538f3b9b&scoped=true"
import script from "./GridSystem.vue?vue&type=script&lang=js"
export * from "./GridSystem.vue?vue&type=script&lang=js"
import style0 from "./GridSystem.vue?vue&type=style&index=0&id=538f3b9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538f3b9b",
  null
  
)

export default component.exports